import { listen } from '@fluorescent/dom';

import { emit } from '@/neon/events';

const queries = {
  small: '(max-width: 40em)',
  medium: '(min-width: 40em) and (max-width: 60em)',
  large: '(min-width: 60em)',
};

export default () => {
  let currentWidth = checkWidth();

  function checkWidth() {
    if (window.matchMedia(queries.small).matches) {
      return 'small';
    } else if (window.matchMedia(queries.medium).matches) {
      return 'medium';
    } else if (window.matchMedia(queries.large).matches) {
      return 'large';
    }
  }

  listen(window, 'resize', () => {
    const windowWidth = checkWidth();

    if (currentWidth !== windowWidth) {
      currentWidth = windowWidth;
      emit(`viewport-resize:${currentWidth}`);
    }
  });
};
